import { ReactElement } from 'react';
import type { MultiSelectProps } from '@mantine/core';
import { MultiSelect as MantineMultiSelect } from '@mantine/core';

export const MultiSelect = (props: MultiSelectProps): ReactElement => {
  return <MantineMultiSelect {...props} />;
};
